import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { currencyFormatterNoTrailingZeros } from '../helpers'
import {
  AccountValue,
  ChangeAmount,
  GainLossContainer,
  Indicator,
  MarketUnit,
  StyledIcon,
  TotalUnit,
} from './styled-components'

const getPercentChangeText = (val: number): string => {
  return `(${val.toFixed(1)}%)`
}

const GainLoss = ({
  accountValue,
  isMarket,
  marketChange,
  marketPercentChange,
  totalChange,
  totalPercentChange,
}: {
  accountValue: number
  isMarket: boolean
  marketChange: number
  marketPercentChange: number
  totalChange: number
  totalPercentChange: number
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()
  const isUp = Math.sign(isMarket ? marketChange : totalChange) > 0

  const icon = (
    <StyledIcon
      icon={isUp ? AcornsIcon.Icon.ArrowUp : AcornsIcon.Icon.ArrowDown}
      width={12}
    />
  )
  return (
    <GainLossContainer isMarket={isMarket}>
      <MarketUnit isActive={isMarket}>
        <AccountValue isSmallFont>
          {currencyFormatterNoTrailingZeros(accountValue)}
        </AccountValue>
        <ChangeAmount>
          {icon} {currencyFormatterNoTrailingZeros(marketChange || 0)}{' '}
          {getPercentChangeText(marketPercentChange || 0)}
        </ChangeAmount>
        <Indicator>
          {getRemoteString({
            key: 'early.recap.performance.market_gain_loss.title',
          })}
        </Indicator>
      </MarketUnit>
      <TotalUnit isActive={!isMarket}>
        <AccountValue isSmallFont>
          {currencyFormatterNoTrailingZeros(accountValue)}
        </AccountValue>
        <ChangeAmount>
          {icon} {currencyFormatterNoTrailingZeros(totalChange || 0)}{' '}
          {getPercentChangeText(totalPercentChange)}
        </ChangeAmount>
        <Indicator>
          {getRemoteString({
            key: 'early.recap.performance.total_gain_loss.title',
          })}
        </Indicator>
      </TotalUnit>
    </GainLossContainer>
  )
}

export { GainLoss }
